export class SystemAjax {
    constructor(className) {
        this.className = className;
        this.params = {};
    }

    addParam(name, value) {
        // Directly assign the value to the params object
        this.params[name] = value;
    }
    
    getParams(){
        return this.params
    }

    async getAnswer(callback) {
        try {
            // Construct the payload
            const payload = {
                className: this.className, // Added className to payload
                params: this.params
            };

            // Log the payload for debugging
            console.log("Sending payload:", JSON.stringify(payload));

            // Send the request
            const response = await fetch(`/api/ajax`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload) // Send the modified payload
            });

            // Check if the response is OK
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // Assuming the response is JSON formatted
            const data = await response.json(); // Changed to response.json()
            const finalData = JSON.parse(data.result)

            // Log the response for debugging
            console.log("Received response:", finalData);

            // Invoke the callback with the parsed data
            callback(finalData);
        } catch (error) {
            console.error('Error:', error);
        }
    }
}
